interface NoticeItem {
  label: string;
  value: string;
}

const noticeItems: NoticeItem[] = [
  { label: "販売業者（事業者名）", value: "株式会社ナンバ" },
  { label: "運営統括責任者", value: "代表取締役 難波 伸敏" },
  { label: "所在地", value: "〒115-0056 東京都北区西が丘2-1-11" },
  { label: "電話番号", value: "03-6454-3314" },
  { label: "メールアドレス", value: "info@namba.ne.jp" },
  { label: "受付時間", value: "平日 9:30〜18:30（土日祝日・年末年始を除く）" },
  {
    label: "サービス名称",
    value: "人材みえる化ソリューションおよびこれに付随するサービス（以下「本サービス」といいます）",
  },
  {
    label: "販売価格",
    value: "サービス内容およびご利用プランにより異なります。具体的な料金については、別途お見積りの上ご案内いたします。",
  },
  {
    label: "商品代金以外の必要料金",
    value: "インターネット接続料、通信料、振込手数料等（いずれもお客様のご負担となります）",
  },
  {
    label: "お支払方法",
    value: "銀行振込（振込手数料はお客様のご負担となります）",
  },
  {
    label: "お支払期限",
    value: "請求書発行日から30日以内にお支払いください。",
  },
  {
    label: "サービスの提供時期",
    value: "ご契約・お申し込み手続きの完了後、速やかに本サービスの提供を開始いたします。",
  },
  {
    label: "申込の有効期限",
    value: "お申し込みの日から14日以内といたします。有効期限内にご契約手続きが完了しない場合、お申し込みは自動的に失効いたします。",
  },
  {
    label: "キャンセル・解約について",
    value: "契約期間中の解約につきましては、別途締結する契約書の定めによるものとします。",
  },
  {
    label: "返品・返金について",
    value: "本サービスの提供開始前にお客様からキャンセルされた場合には、既にお支払いいただいた代金を返金いたします。提供開始後は、契約書の定めによる場合を除き、返金はいたしかねます。",
  },
  {
    label: "不良・不具合について",
    value: "本サービスに不具合が生じた場合には、合理的な期間内に調査・対応いたします。",
  },
  {
    label: "準拠法・裁判管轄",
    value: "日本法を準拠法とし、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。",
  },
];

const notes = [
  "本表記に記載のない事項につきましては、利用規約および別途締結する契約書の定めによるものとします。",
  "販売価格は、サービス内容・ご利用プラン・導入規模により変動いたします。最終的な料金は、別途お見積り書をもって確定するものとし、本表記はあくまで目安となります。",
  "お客様のご利用環境（インターネット回線、端末、ブラウザ等）により、本サービスの一部機能が正常に動作しない場合があります。",
  "本サービスの利用によりお客様に生じた損害について、当社は利用規約に定める範囲を超えて責任を負いません。",
  "本表記の内容は、法令の改正や事業内容の変更に伴い、予告なく変更する場合があります。変更後の内容は、本ウェブサイトに掲載した時点から効力を生じます。",
];

export default function LegalNoticeSections() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <dl className="font-body text-sm leading-relaxed text-foreground-800">
            {noticeItems.map((item, index) => (
              <div
                key={item.label}
                className={`grid grid-cols-1 gap-1 p-5 sm:grid-cols-[12rem_1fr] sm:gap-4 md:p-6 ${
                  index % 2 === 1 ? "bg-background-100/70" : "bg-background-50"
                } ${index !== noticeItems.length - 1 ? "border-b border-background-200" : ""}`}
              >
                <dt className="font-label text-sm font-bold text-foreground-950">
                  {item.label}
                </dt>
                <dd className="text-foreground-700">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100/70 p-6 md:p-8">
          <h2 className="mb-4 font-heading text-base font-bold text-foreground-950">
            注記・免責事項
          </h2>
          <ul className="space-y-3 font-body text-xs leading-relaxed text-foreground-600">
            {notes.map((note) => (
              <li key={note} className="flex gap-2">
                <span className="mt-0.5 shrink-0 text-primary-500">※</span>
                <span>{note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}